import { ReactElement, ReactNode } from "react";
import { Button } from "src/components/ui/button";
import { SurveyFull } from "src/redux/survey/survey.types";
import { ReactComponent as Loading } from 'src/assets/icons/loading.svg';
import { Plus } from "lucide-react";

interface SurveySummaryResultsLayoutProps {
  isEmpty?: boolean;
  emptyStateText: string;
  emptyStateDescription: string;
  body: ReactNode;
  survey?: SurveyFull;
  isLoading: boolean;
  isShare?: boolean;
  create?: () => void;
}

const SurveySummaryResultsLayout = ({ isEmpty, emptyStateText, emptyStateDescription, body, survey, isLoading, isShare, create }: SurveySummaryResultsLayoutProps): ReactElement | null => {
  if (!survey) {
    return null;
  }

  const handleCreation = (): void => {
    if (isLoading || !create) {
      return;
    }
    void create();
  };

  return (
    <div>
      {isEmpty ? (
        isLoading ? (
          <Loading className="animate-spin stroke-black" />
        ) : (
          !isShare && (
            <div
              className="flex gap-3 p-3 pr-6 rounded-3xl bg-gray-200 hover:bg-gray-400 cursor-pointer inline-flex"
              onClick={handleCreation}
            >
              <div className={`flex shrink-0 size-8 bg-blue-500 rounded-full items-center justify-center self-center`}>
                <Plus className="size-[18px] stroke-white" />
              </div>
              <div>
                <p className="font-bold">
                  {emptyStateText}
                </p>
                <p className="text-sm">
                  {emptyStateDescription}
                </p>
              </div>
            </div>
          )
        )
      ) : (
        <div>
          <div className="relative">
            {!isShare && (
              <div>
                <Button
                  onClick={handleCreation}
                  variant="outline"
                  size="smallIcon"
                  className="shadow-sm absolute top-0 right-0"
                  title="Rerun"
                >
                  <i
                    className="pi pi-replay"
                    style={{ fontSize: '1rem' }}
                  />
                </Button>
              </div>
            )}
          </div>
          {isLoading ? <Loading className="animate-spin stroke-black" /> : body}
        </div>
      )}
    </div>
  );
};

export default SurveySummaryResultsLayout;
